import { theme as antdTheme } from "antd";

export const getAntdTheme = (darkMode) => ({
  algorithm: darkMode
    ? antdTheme.darkAlgorithm
    : antdTheme.defaultAlgorithm,

  token: {
    colorBgLayout: darkMode ? "#0f172a" : "#f5f5f5",
    colorBgContainer: darkMode ? "#1a2035" : "#ffffff",
    colorText: darkMode ? "#ffffff" : "#000000",
    colorBorder: darkMode ? "#475894" : "#d9d9d9",
    colorPrimary: "#1890ff",
  },

  components: {
    Input: {
      colorBgContainer: darkMode ? "#1a2035" : "#fff",
      colorText: darkMode ? "#fff" : "#000",
      colorBorder: darkMode ? "#475894" : "#d9d9d9",
    },

    Select: {
      colorBgContainer: darkMode ? "#1a2035" : "#fff",
      colorText: darkMode ? "#fff" : "#000",
      colorBorder: darkMode ? "#475894" : "#d9d9d9",
      optionActiveBg: darkMode ? "#1f2937" : "#f5f5f5",
      optionSelectedBg: darkMode ? "#1a243b" : "#e6f4ff",
    },

    DatePicker: {
      colorBgContainer: darkMode ? "#1a2035" : "#fff",
      colorText: darkMode ? "#fff" : "#000",
      colorBorder: darkMode ? "#475894" : "#d9d9d9",
      colorBgElevated: darkMode ? "#1f2937" : "#fff",
    },

    Switch: {
      colorPrimary: "#1890ff",
    },

    Checkbox: {
      colorPrimary: "#1890ff",
    },

    Radio: {
      colorPrimary: "#1890ff",
    },
  },
});